/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Datumfeedbackunterlagenerhalten2Inputs */

const de__field_datumfeedbackunterlagenerhalten2 = /** @type {(inputs: _Field_Datumfeedbackunterlagenerhalten2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum Feedbackunterlagen erhalten`)
};

/**

* @param {_Field_Datumfeedbackunterlagenerhalten2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_datumfeedbackunterlagenerhalten2 = /** @type {((inputs?: _Field_Datumfeedbackunterlagenerhalten2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Datumfeedbackunterlagenerhalten2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_datumfeedbackunterlagenerhalten2(inputs)
});
export { _field_datumfeedbackunterlagenerhalten2 as "_field_datumFeedbackunterlagenErhalten" }